import { render, staticRenderFns } from "./OrderViewSkeleton.vue?vue&type=template&id=730e58ed"
import script from "./OrderViewSkeleton.vue?vue&type=script&lang=js"
export * from "./OrderViewSkeleton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports